import { useStore } from 'vuex';

/**
 * Settings entity list helper — afterMutation refreshes drivers bootstrap.
 */
export function useSettingsEntityList() {
  const store = useStore();

  const afterMutation = async (reloadFn) => {
    if (typeof reloadFn === 'function') {
      await reloadFn();
    }
    try {
      await store.dispatch('app/fetchBootstrap');
    } catch {
      // Bootstrap refresh is best-effort after settings mutation
    }
  };

  return {
    afterMutation
  };
}
